import React, { useContext, useState } from 'react';
import { Button, Modal } from 'antd';
import ResumeUploadModal from '../../modal/resume';
import styles from './styles.module.scss';
import { IsAdminContext } from '../../../../context';

//component for resume uploading
const ResumeUpload: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isAdmin = useContext(IsAdminContext);

  const showModal = (e: any) => {
    if (isAdmin === '1') {
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <Button
        className={styles.button}
        type="primary"
        onClick={showModal}
        style={{
          backgroundColor: '#8CC63E',
          borderRadius: '4px',
          width: '100px',
          border: 'none',
          padding: '4px 10px',
          color: 'white',
          fontWeight: '700',
          display: isAdmin === '1' ? 'none' : '',
        }}
      >
        Upload File
      </Button>
      <ResumeUploadModal {...{ isModalOpen, setIsModalOpen }} />
    </>
  );
};

export default ResumeUpload;
